import React from "react";

import { FoulingTypes } from "constants/constantStrings";

import DoubleArrowIcon from "assets/SvgIcon/DoubleArrowIcon";
import DownIcon from "assets/SvgIcon/DownIcon";
import NextIcon from "assets/SvgIcon/NextIcon";

import "./index.scss";

const foulingParamConfigs = {
  increasing: {
    img: <DownIcon height="25" width="25" classes={"rotate increasing-green"} />,
    text: FoulingTypes.increasing,
    color: "green-text"
  },
  rapidlyIncreasing: {
    img: <DoubleArrowIcon classes={" increasing-green"} />,
    text: FoulingTypes.rapidlyIncreasing,
    color: "green-text"
  },
  decreasing: {
    img: <DownIcon height="25" width="25" classes={"decreasing-red"} />,
    text: FoulingTypes.decreasing,
    color: "red-text"
  },
  rapidlyDecreasing: {
    img: <DoubleArrowIcon classes={" rotate decreasing-red"} />,
    text: FoulingTypes.rapidlyDecreasing,
    color: "red-text"
  },
  notChanging: {
    img: <NextIcon height="25" width="25" type="disabled" />,
    text: FoulingTypes.notChanging
  }
};

const FoulingParamComponent = (type, linear, optional) => {
  const { img, text, color } = foulingParamConfigs[type];
  return (
    <div className="flex-ai-center ">
      {img}
      <h3 className={color}>
        {linear ? FoulingTypes.linear : FoulingTypes.nonLinear}
        {text}
        {optional ? FoulingTypes.optional : ""}
      </h3>
    </div>
  );
};

export const foulingTypeData = {
  Normal_Fouling_Type: {
    name: FoulingTypes.noFouling,
    permeateFlow: FoulingParamComponent("notChanging", true),
    saltPassage: FoulingParamComponent("notChanging", true),
    differentialPressure: FoulingParamComponent("notChanging", true),
    directCause: "",
    indirectCause: "",
    recommendation: ""
  },
  Organic_Fouling_Type: {
    name: FoulingTypes.organicFouling,
    permeateFlow: FoulingParamComponent("decreasing"),
    saltPassage: FoulingParamComponent("decreasing", false, true),
    differentialPressure: FoulingParamComponent("notChanging", true, true),
    directCause: FoulingTypes.organicFouling,
    indirectCause: "Oil, cationic polyelectrolytes water hammer",
    recommendation: "Cleaning, improve pretreatment"
  },
  Biofouling_Fouling_Type: {
    name: FoulingTypes.bioFouling,
    permeateFlow: FoulingParamComponent("decreasing", false, true),
    saltPassage: FoulingParamComponent("increasing", false, true),
    differentialPressure: FoulingParamComponent("increasing", false),
    directCause: FoulingTypes.bioFouling,
    indirectCause: "Contaminated raw water, insufficient pretreatment",
    recommendation: "Cleaning, disinfection, improve pretreatment"
  },
  Scaling_Fouling_Type: {
    name: FoulingTypes.scalingFouling,
    permeateFlow: FoulingParamComponent("decreasing", true, true),
    saltPassage: FoulingParamComponent("increasing", true),
    differentialPressure: FoulingParamComponent("increasing", true, true),
    directCause: FoulingTypes.scalingFouling,
    indirectCause: "Insufficient scale control",
    recommendation: "Cleaning, scale control"
  },
  Particulate_Colloidal_Fouling_Type: {
    name: FoulingTypes.particulateFouling,
    permeateFlow: FoulingParamComponent("rapidlyDecreasing", true, true),
    saltPassage: FoulingParamComponent("rapidlyIncreasing", true, true),
    differentialPressure: FoulingParamComponent("rapidlyIncreasing", true, false),
    directCause: FoulingTypes.colloidalFouling,
    indirectCause: "Insufficient pretreatment",
    recommendation: "Cleaning, improve pretreatment"
  },
  Integrity_Mech_Fail_Fouling_Type: {
    name: FoulingTypes.integrityFailure,
    permeateFlow: FoulingParamComponent("increasing", true),
    saltPassage: FoulingParamComponent("increasing", true),
    differentialPressure: FoulingParamComponent("notChanging", true, true),
    directCause: FoulingTypes.mechanicalDamage,
    indirectCause: "Chemical reactions",
    recommendation: "Membrane replacement"
  }
};
